/*
 * rn-farina-cliq.js — vanilla-JS rebuild of the interactive widgets on the Replo-built
 * "Farina & Free Cliq" bundle page (product 7783095140467), for the native Shopify
 * recreation (sections/rn-farina-cliq.liquid + snippets/rn-farina-cliq-01..15). No Replo
 * runtime ships on this page — everything below is a from-scratch reimplementation driven
 * off the SAME data-* attributes Replo left in the extracted markup, scoped to
 * .rn-farina-cliq only.
 *
 * Carousel / collapsible / entrance-animation engines are the same generic pattern proven
 * on the HELIOS ring native port (.agents/replo-native/assets/replo-native.js) — this page
 * has 0 tabs (Radix tabs), so that engine isn't ported here.
 *
 * ADD-TO-CART FLOW — verified directly against the Replo runtime bundle
 * (replocdn.com/.../elementPreview/f8a92c44-....min.js), not guessed:
 *   1. Three "ADD TO CART" triggers all just OPEN A MODAL (componentId
 *      59f3ee5f-a63f-4df8-a718-f63974eb7168, an upsell/order-bump popup selling a
 *      separate "Cycling Essentials Pack"): the main hero button, the desktop sticky bar
 *      button, and the mobile sticky bar button. None of the 3 add anything to cart by
 *      themselves.
 *   2. Inside the modal, THREE elements can add to cart:
 *      - "ADD & PROCEED TO CHECKOUT" (accept the upsell): clearCart -> add the bundle
 *        (qty 1) + add the "Essentials Pack" upsell item -> redirect straight to
 *        /checkout. Source config: two addProductVariantToCart actions, no
 *        /cart/update.js drawer step (redirectToCheckout:true on the 2nd item).
 *      - "DECLINE & PROCEED TO CART" and the "X" close icon: functionally IDENTICAL in
 *        the source runtime — both do closeModalComponent + addProductVariantToCart
 *        (bundle only) + a POST /cart/update.js that renders the theme's native
 *        cart-drawer. Ported as one shared handler.
 *   3. The bundle's own hidden <product-form> (found in every sticky-bar snippet, 6
 *      forms total) is NOT used for the click-to-submit pattern seen on the ring page —
 *      it's dead/unused markup here, kept verbatim per "extract code, never redraw".
 *
 * KNOWN GAP (source-side, not introduced by this port): the "Essentials Pack" upsell
 * product (productId 7833657180275 / variantId 42552083120243) referenced by the ACCEPT
 * path does not exist in the store (confirmed via Admin GraphQL - both product and
 * variant queries return null). The accept path is ported byte-for-byte faithful to the
 * source config anyway; that add legitimately 422s server-side on both the live Replo
 * page and this port. See BUILD-LOG.md for detail. Do not silently fix - flagged only.
 */
(function () {
  "use strict";

  var ROOT_SELECTOR = ".rn-farina-cliq";

  var BUNDLE_PRODUCT_ID = 7783095140467;
  var BUNDLE_VARIANT_ID = 42343190069363; /* "Farina & Free Cliq" bundle, Default Title, $199.00 */

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function openCartDrawer() {
    var cd = document.querySelector("cart-drawer");
    return postJSON("/cart/update.js", {
      updates: {},
      sections: ["cart-drawer", "cart-icon-bubble"],
      sections_url: window.location.pathname
    }).then(function (data) {
      if (!cd) return data;
      if (typeof cd.renderContents === "function") {
        cd.renderContents(data);
      } else {
        cd.classList.add("animate", "active");
      }
      try {
        var freshCd = new DOMParser()
          .parseFromString(data.sections["cart-drawer"], "text/html")
          .querySelector("cart-drawer");
        if (freshCd) cd.classList.toggle("is-empty", freshCd.classList.contains("is-empty"));
      } catch (e) {}
      return data;
    });
  }

  /* ============================================================
   * 1. ADD TO CART — direct (Leo, 2026-09-02)
   * ============================================================
   * The source page routed all three "ADD TO CART" buttons through a legacy "Cycling
   * GOLD/Essentials Pack" upsell modal (componentId 59f3ee5f) whose accept path pointed
   * at a product that no longer exists. Leo: "This is a legacy item. We should delete it.
   * When they add to cart, it should just add the product that they clicked on." So the
   * hero button and both sticky bars now add the bundle variant straight to the cart and
   * open the theme cart drawer — the exact behaviour the old DECLINE path had. The modal
   * snippet is no longer rendered by the section.
   */
  function initDirectAddToCart() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var selectors = [
      '[data-rn-open-modal="hero"]',
      '[data-rn-open-modal="sticky-desktop"]',
      '[data-rn-open-modal="sticky-mobile"]'
    ];
    selectors.forEach(function (sel) {
      var el = root.querySelector(sel);
      if (!el) return;
      el.setAttribute("data-rn-atc", "bundle");
      el.addEventListener("click", function (e) {
        e.preventDefault();
        if (el.getAttribute("aria-disabled") === "true") return;
        el.setAttribute("aria-disabled", "true");
        el.style.pointerEvents = "none";
        el.style.opacity = "0.6";
        postJSON("/cart/add.js", { items: [{ id: BUNDLE_VARIANT_ID, quantity: 1 }] })
          .then(openCartDrawer)
          .catch(function (err) { console.error("[rn-farina-cliq] add-to-cart failed", err); })
          .finally(function () {
            el.removeAttribute("aria-disabled");
            el.style.pointerEvents = "";
            el.style.opacity = "";
          });
      });
    });
  }

  /* ============================================================
   * 2. STICKY ADD-TO-CART BARS — scroll-triggered visibility
   * ============================================================
   * Source behavior (confirmed live against the preview): both bars ship
   * `position:fixed;bottom:0;display:none` unconditionally; Replo's runtime adds a 2nd
   * class (r-148y52s desktop / r-1r26raj mobile) once the hero/buybox has scrolled out of
   * view, which is what actually flips display to flex (base @media rules already pick
   * the correct ONE of the two bars for the current breakpoint - see assets/rn-farina-
   * cliq.css). We reproduce the same 2-class toggle with an IntersectionObserver watching
   * the hero snippet instead of a hard scrollY threshold, so it stays correct if the hero
   * height ever changes.
   */
  function initStickyBars() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var hero = root.querySelector('[data-rn-hero-buybox]');
    var desktopBar = root.querySelector('[data-rn-sticky="desktop"]');
    var mobileBar = root.querySelector('[data-rn-sticky="mobile"]');
    if (!hero || (!desktopBar && !mobileBar)) return;

    var DESKTOP_TOGGLE_CLASS = "r-148y52s";
    var MOBILE_TOGGLE_CLASS = "r-1r26raj";

    function setVisible(bar, cls, visible) {
      if (!bar) return;
      bar.classList.toggle(cls, visible);
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            /* entry.isIntersecting === false once the hero has fully scrolled past the
               top of the viewport (rootMargin below narrows the trigger line to the very
               top edge, matching "scrolled past the buybox" rather than "buybox merely
               not centered") */
            var pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            setVisible(desktopBar, DESKTOP_TOGGLE_CLASS, pastHero);
            setVisible(mobileBar, MOBILE_TOGGLE_CLASS, pastHero);
          });
        },
        { root: null, rootMargin: "0px", threshold: 0 }
      );
      io.observe(hero);
    } else {
      window.addEventListener("scroll", function () {
        var pastHero = hero.getBoundingClientRect().bottom < 0;
        setVisible(desktopBar, DESKTOP_TOGGLE_CLASS, pastHero);
        setVisible(mobileBar, MOBILE_TOGGLE_CLASS, pastHero);
      });
    }
  }

  /* ============================================================
   * 3. CAROUSELS — [data-replo-carousel="true"]  (5 total on this page)
   * ============================================================ */
  function initCarousels() {
    var roots = document.querySelectorAll(ROOT_SELECTOR + ' [data-replo-carousel="true"]');
    roots.forEach(function (root) {
      var track = root.querySelector('[data-replo-part="slide-track"]');
      if (!track) return;

      /* --replo-carousel-slides-per-page (used by the slide-width calc() below) is a
         VALUE Replo's own React runtime recomputes live per breakpoint — our static HTML
         capture only froze whatever it resolved to at capture time (1440px desktop), so a
         multi-per-page carousel (this page's testimonials carousel: 3-up desktop, 1-up
         mobile) would otherwise stay stuck at "3" even at mobile widths, squeezing 3 cards
         into one viewport instead of showing one full-width card. Confirmed live against
         the source preview at 8 widths: exactly 1 at <=640px, exactly 3 at >=641px (the
         theme's own mobile/desktop breakpoint) - reapply responsively. Carousels whose
         captured value is already 1 (single-slide carousels) are unaffected either way.
         */
      var capturedPerPage = track.style.getPropertyValue("--replo-carousel-slides-per-page").trim();
      function applyResponsivePerPage() {
        if (!capturedPerPage) return;
        var target = window.innerWidth <= 640 ? "1" : capturedPerPage;
        track.style.setProperty("--replo-carousel-slides-per-page", target);
      }
      applyResponsivePerPage();

      var prevBtn = root.querySelector('[data-replo-part="nav-button"][data-direction="previous"]');
      var nextBtn = root.querySelector('[data-replo-part="nav-button"][data-direction="next"]');
      /* fc2 (Leo 2026-09-03: "the left arrow doesn't work"): Replo captured prev as disabled="" on slide 1
         (non-looping runtime). goTo() below wraps, so both arrows are always live. */
      [prevBtn, nextBtn].forEach(function (b) { if (b) { b.removeAttribute("disabled"); b.removeAttribute("aria-disabled"); } });

      var rawSlides = Array.prototype.slice.call(track.querySelectorAll('[data-replo-part="slide"]'));
      if (!rawSlides.length) return;

      var seen = {};
      var order = [];
      rawSlides.forEach(function (el) {
        var idx = el.getAttribute("data-slide-source-index") || el.getAttribute("data-slide-index") || "0";
        if (!(idx in seen)) {
          seen[idx] = el;
          order.push(idx);
        } else if (el.getAttribute("data-is-target") === "true") {
          seen[idx].parentNode && seen[idx].parentNode.removeChild(seen[idx]);
          seen[idx] = el;
        } else {
          el.parentNode && el.parentNode.removeChild(el);
        }
      });
      /* Clone slides for the infinite-loop illusion are frequently positioned BEFORE the
         real first slide in DOM order (confirmed on this page's "problem grid" carousel:
         raw order was [4,1,2,3,0] because a clone of slide 4 leads the track) - sort back
         into numeric source-slide order so index 0 is always slide 0, not whatever
         happened to appear first in the markup. */
      order.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
      var slides = order.map(function (idx) { return seen[idx]; });
      Array.prototype.slice.call(track.children).forEach(function (child) {
        if (slides.indexOf(child) === -1) track.removeChild(child);
      });
      /* appendChild on an already-attached node MOVES it - re-assert DOM order to match
         the sorted `slides` array so translate3d(index * step) actually lands on the
         right visual slide (sorting the JS array alone doesn't reorder existing DOM
         children). */
      slides.forEach(function (s) { track.appendChild(s); });

      if (slides.length < 2) {
        if (prevBtn) prevBtn.style.display = "none";
        if (nextBtn) nextBtn.style.display = "none";
        return;
      }

      var current = 0;
      slides.forEach(function (s, i) {
        s.style.flexShrink = "0";
        s.setAttribute("aria-hidden", i === 0 ? "false" : "true");
        s.setAttribute("tabindex", i === 0 ? "0" : "-1");
        s.setAttribute("data-is-active", i === 0 ? "true" : "false");
      });
      track.style.transitionProperty = "transform";
      track.style.transitionDuration = "380ms";
      track.style.transitionTimingFunction = "cubic-bezier(0.4, 0, 0.2, 1)";

      function gapPx() {
        var g = getComputedStyle(track).columnGap || getComputedStyle(track).gap || "0px";
        var n = parseFloat(g);
        return isNaN(n) ? 0 : n;
      }

      /* Most slides on this page carry their own `width:calc((100% + gap)/var(--replo-
         carousel-slides-per-page,1) - gap)` inline style, which resolves correctly on its
         own once applyResponsivePerPage() above sets the CSS var - leave those alone.
         ONE carousel on this page (the "problem grid") ships slide nodes with NO width in
         their captured inline style at all (only their inner content wrapper has one) -
         a flex item with display:flex and no width/flex-basis sizes to its content's
         max-content instead of the track width, blowing the slide out to ~1200px and the
         section height along with it. Only backfill a JS-computed pixel width for slides
         that are genuinely missing one; never override a slide that already has its own
         calc(), which is how the hero image carousel's "1 slide at a time, no peek of the
         next" framing stays correct. */
      function applySlideWidths() {
        var perPageStr = track.style.getPropertyValue("--replo-carousel-slides-per-page");
        var perPage = parseFloat(perPageStr) || 1;
        var gap = gapPx();
        var trackWidth = track.getBoundingClientRect().width;
        var width = (trackWidth + gap) / perPage - gap;
        if (width <= 0) return;
        slides.forEach(function (s) {
          var inlineStyle = s.getAttribute("style") || "";
          if (inlineStyle.indexOf("width:") === -1 && inlineStyle.indexOf("width :") === -1) {
            /* fc2 (Leo 2026-09-03, "this is incomplete"): the problem-grid cards are ~300px content
               boxes; the Replo runtime shows as many as fit (4 at 1440) and steps one card at a time.
               Size the slide to its card, not the whole track, so the row fills. */
            var card = s.firstElementChild; var cw = card ? card.getBoundingClientRect().width : 0;
            s.style.width = (cw > 0 && cw < width * 0.8 ? cw : width) + "px";
          }
        });
      }
      applySlideWidths();

      function goTo(index, opts) {
        var silent = opts && opts.silent;
        current = ((index % slides.length) + slides.length) % slides.length;
        var slideRect = slides[0].getBoundingClientRect();
        var step = slideRect.width + gapPx();
        track.style.transitionDuration = silent ? "0ms" : "380ms";
        track.style.transform = "translate3d(" + -1 * current * step + "px,0,0)";
        slides.forEach(function (s, i) {
          var active = i === current;
          s.setAttribute("aria-hidden", active ? "false" : "true");
          s.setAttribute("tabindex", active ? "0" : "-1");
          s.setAttribute("data-is-active", active ? "true" : "false");
        });
      }

      if (prevBtn) prevBtn.addEventListener("click", function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { goTo(current + 1); });
      /* fc2 dots (Leo 2026-09-03): Replo captured the indicator dots as static role=button divs
         (aria-label "Go to slide N", active class r-1mmzspo). Make them tappable and repaint on every move. */
      var dots = Array.prototype.slice.call(root.querySelectorAll('[role="button"][aria-label^="Go to slide"]'));
      if (dots.length) {
        var activeCls = (dots[0].className.split(/\s+/).filter(function (c) { return c !== "r-1hl7ym7" && c; })[0]) || "r-1mmzspo";
        var paintDots = function () { dots.forEach(function (d, i) { var on = i === current; d.setAttribute("aria-current", on ? "true" : "false"); d.classList.toggle(activeCls, on); }); };
        var _goTo = goTo; goTo = function (i, o) { _goTo(i, o); paintDots(); };
        dots.forEach(function (d, i) { d.addEventListener("click", function (e) { e.preventDefault(); goTo(i); }); });
      }

      var startX = null, deltaX = 0, dragging = false;
      track.style.touchAction = "pan-y";
      track.addEventListener("pointerdown", function (e) {
        dragging = true;
        startX = e.clientX;
        track.style.transitionDuration = "0ms";
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        deltaX = e.clientX - startX;
        var slideRect = slides[0].getBoundingClientRect();
        var step = slideRect.width + gapPx();
        track.style.transform = "translate3d(" + (-1 * current * step + deltaX) + "px,0,0)";
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        var slideRect = slides[0].getBoundingClientRect();
        var step = slideRect.width + gapPx();
        if (Math.abs(deltaX) > step * 0.2) {
          goTo(current + (deltaX < 0 ? 1 : -1));
        } else {
          goTo(current);
        }
        deltaX = 0;
      }
      track.addEventListener("pointerup", endDrag);
      track.addEventListener("pointercancel", endDrag);
      track.addEventListener("pointerleave", function () { if (dragging) endDrag(); });

      var resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          applyResponsivePerPage();
          applySlideWidths();
          goTo(current, { silent: true });
        }, 120);
      });

      goTo(0, { silent: true });
    });
  }

  /* ============================================================
   * 4. COLLAPSIBLES / ACCORDIONS — [data-replo-collapsible="true"]  (18 total)
   * ============================================================ */
  function initCollapsibles() {
    var roots = document.querySelectorAll(ROOT_SELECTOR + ' [data-replo-collapsible="true"]');
    roots.forEach(function (root) {
      var trigger = root.querySelector('[role="button"][aria-controls]');
      if (!trigger) return;
      var panelId = trigger.getAttribute("aria-controls");
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;
      function toggle() {
        var isOpen = trigger.getAttribute("aria-expanded") === "true";
        var next = !isOpen;
        trigger.setAttribute("aria-expanded", next ? "true" : "false");
        root.setAttribute("data-state", next ? "open" : "closed");
        if (next) panel.removeAttribute("hidden");
        else panel.setAttribute("hidden", "");
      }
      trigger.addEventListener("click", toggle);
      trigger.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  /* ============================================================
   * 5. ENTRANCE ANIMATIONS — same generic un-pauser as the ring build
   * ============================================================ */
  function initEntranceAnimations() {
    var all = document.querySelectorAll(ROOT_SELECTOR + " *");
    var candidates = [];
    all.forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.animationPlayState === "paused" && cs.animationName && cs.animationName !== "none") {
        candidates.push(el);
      }
    });
    if (!candidates.length) return;
    if (!("IntersectionObserver" in window)) {
      candidates.forEach(function (el) { el.style.animationPlayState = "running"; });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.animationPlayState = "running";
            io.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px 0px -10% 0px", threshold: 0.01 }
    );
    candidates.forEach(function (el) { io.observe(el); });
  }

  function init() {
    initDirectAddToCart();
    initStickyBars();
    initCarousels();
    initCollapsibles();
    initEntranceAnimations();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
